import React from "react"
import { Box } from "@infotech/uikit-grid"
import styles from "./styles.css"

const caption = `Чтобы добавить ресурсы, создайте план на вкладке "Общая информация".`

const NewPlanConstraint = () => (
  <Box loose flex className={styles.NewResourcesWrapper}>
    <Box loose className={styles.ContentColumn} pt="2md" pl="2md">
      <Box loose className={styles.ContentHeader}>
        Ресурсы в плане
      </Box>
      <Box loose className={styles.ContentCaption}>
        {caption}
      </Box>
    </Box>
    <Box loose className={styles.ContentColumn} pt="2md" pl="2md">
      <Box loose className={styles.ContentHeader}>
        Дополнительные ресурсы
      </Box>
      <Box loose className={styles.ContentCaption}>
        {caption}
      </Box>
    </Box>
  </Box>
)

export default NewPlanConstraint
